/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupUserDetailsRoutingModule } from './builder-setup-user-details-routing.module';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserListTabComponent } from './components/user-list-tab/user-list-tab.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserDetailsBusinessService } from './resources/user-details-business.service';
import { UserListBusinessService } from './resources/user-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupUserDetailsRoutingModule,
  ],
  providers: [
    UserListBusinessService,
    UserDetailsBusinessService,
  ],
  declarations: [
    UserListTabComponent,
    UserListComponent,
    UserDetailsComponent,
  ],
})
export class BuilderSetupUserDetailsModule {
}
